import React from 'react';
import { TableHeader } from '@ingka/table';
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';
import { ColumnDefinition, SortModel } from '../../../../../models';
import { spanColumnGroups } from '../../../../functions/pivotRows';

interface GridTableHeaderProps {
  columns: ColumnDefinition[];
  sortModel: SortModel[];
  onToggleSort: (field: string, shiftKey: boolean) => void;
}

const GridTableHeader: React.FC<GridTableHeaderProps> = ({
  columns,
  sortModel,
  onToggleSort,
}) => {
  const visibleColumns = columns.filter(column => column.show);
  const hasColumnGroups = visibleColumns.some(column => column.group);

  return (
    <TableHeader sticky>
      {hasColumnGroups && (
        <tr>
          {spanColumnGroups(visibleColumns).map(({ group, span }, index) => (
            <th
              key={index}
              colSpan={span}
              className={[
                'pivot-column-group',
                group && 'pivot-column-group--labelled',
                index > 0 && 'pivot-group-start',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {group}
            </th>
          ))}
        </tr>
      )}
      <tr>
        {columns.map(
          ({ field, label, show, groupStart }) =>
            show && (
              <th
                key={String(field)}
                className={groupStart ? 'pivot-group-start' : undefined}
                onClick={e => onToggleSort(String(field), e.shiftKey)}
                style={{ cursor: 'pointer' }}
              >
                {label}
                {(() => {
                  const sort = sortModel.find(s => s.field === field);
                  if (!sort) return '';
                  return sort.order === 'asc' ? (
                    <CaretUpFill />
                  ) : (
                    <CaretDownFill />
                  );
                })()}
              </th>
            )
        )}
      </tr>
    </TableHeader>
  );
};

export default GridTableHeader;
